<div>
  <app-body>
    Looks like there was an issue with the&nbsp;
    <app-body bold>network connection.&nbsp;</app-body>
    We need to reload the app.&nbsp;
    <app-body (click)="reload()" bold ink="system-blue" tid="reload-app-link" id="reload-app-link">Reload</app-body>
  </app-body>
  <br />
</div>
